import { updateField } from './updateField';
export const clearPreselected = (formField = {}, handleUpdate = field => field) => handleUpdate(updateField(formField, 'selectedOptions', []));